export default __webpack_public_path__ + "static/media/Meeting room 2.5399567e.jpg";